var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "tr",
    { attrs: { "data-id": _vm.discountDetails?._id } },
    [
      _c("td", { staticClass: "discount-name" }, [
        _vm._v(_vm._s(_vm.discountDetails?.discountName)),
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          {
            staticClass: "description",
            on: {
              click: function ($event) {
                _vm.isFullDescriptionShown = !_vm.isFullDescriptionShown
              },
            },
          },
          [
            !_vm.isFullDescriptionShown &&
            _vm.discountDetails?.description.length > 70
              ? _c(
                  "span",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.truncatedDescription) +
                        "\n                "
                    ),
                    _c(
                      "v-icon",
                      {
                        staticClass: "ml-1",
                        attrs: { size: "20", color: "#212121" },
                      },
                      [
                        _vm._v(
                          "\n                    mdi-menu-down\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c("span", [_vm._v(_vm._s(_vm.discountDetails?.description))]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("td", [_vm._v(_vm._s(_vm.translateDiscountType))]),
      _vm._v(" "),
      _c(
        "td",
        [
          _vm.discountDetails?.discountType !== "fixprice"
            ? _c("div", { staticClass: "font-weight-bolder" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.discountDetails?.discountValue) +
                    "\n        "
                ),
              ])
            : _vm._l(_vm.formatFixPriceValues("fixPrice"), function (price) {
                return _c("FixedPriceCellContent", {
                  key: price.label,
                  staticClass: "v-application d-flex",
                  attrs: { price: price, discount: _vm.discountDetails },
                })
              }),
        ],
        2
      ),
      _vm._v(" "),
      _c("td", [_vm._v(_vm._s(_vm.translateDiscountTypeFlatRate))]),
      _vm._v(" "),
      _c(
        "td",
        [
          _vm.discountDetails?.flatRateDiscountType !== "fixprice"
            ? _c("div", { staticClass: "font-weight-bolder" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.discountDetails?.flatRateDiscountValue) +
                    "\n        "
                ),
              ])
            : _vm._l(
                _vm.formatFixPriceValues("flatRateFixPrice"),
                function (price) {
                  return _c("FixedPriceCellContent", {
                    key: price.label,
                    staticClass: "v-application d-flex",
                    attrs: { price: price, discount: _vm.discountDetails },
                  })
                }
              ),
        ],
        2
      ),
      _vm._v(" "),
      _c("td", { staticClass: "date" }, [
        _vm._v(_vm._s(_vm.discountDetails?.startDate)),
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "date" }, [
        _vm._v(_vm._s(_vm.discountDetails?.endDate)),
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          { staticClass: "v-application--is-ltr" },
          [
            _c("v-switch", {
              staticClass: "toggle-discount-btn",
              attrs: { dense: "" },
              on: { change: _vm.toggleDiscountStatus },
              model: {
                value: _vm.updatedDiscount.isActive,
                callback: function ($$v) {
                  _vm.$set(_vm.updatedDiscount, "isActive", $$v)
                },
                expression: "updatedDiscount.isActive",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("td", [
        _c(
          "div",
          { staticClass: "action-btn-container" },
          [
            _c(
              "v-btn",
              {
                staticClass: "btn-link",
                attrs: { "x-small": "", fab: "", outlined: "", text: "" },
                on: {
                  click: function ($event) {
                    _vm.isLinkedPharmaciesDialogOpen = true
                  },
                },
              },
              [
                _c(
                  "v-icon",
                  { staticStyle: { margin: "0 8px" }, attrs: { small: "" } },
                  [
                    _vm._v(
                      "\n                    mdi-clipboard-account\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "btn-edit",
                attrs: { "x-small": "", fab: "", outlined: "", text: "" },
                on: {
                  click: function ($event) {
                    _vm.isEditDialogOpen = true
                  },
                },
              },
              [_c("v-icon", { attrs: { small: "" } }, [_vm._v("mdi-pencil")])],
              1
            ),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass: "btn-delete",
                attrs: {
                  "x-small": "",
                  fab: "",
                  outlined: "",
                  text: "",
                  color: "error",
                  disabled: _vm.shouldDeleteBeDisabled,
                },
                on: {
                  click: function ($event) {
                    _vm.isDeleteDiscountDialogOpen = true
                  },
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v("mdi-trash-can-outline"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("DiscountFormDialog", {
        attrs: {
          dialogTitle: "Bearbeiten Rabatt",
          ctaTitle: "Rabatt bearbeiten",
          isDiscountFormDialogOpen: _vm.isEditDialogOpen,
        },
        on: {
          "update:isDiscountFormDialogOpen": function ($event) {
            _vm.isEditDialogOpen = $event
          },
          "update:is-discount-form-dialog-open": function ($event) {
            _vm.isEditDialogOpen = $event
          },
          refresh: function ($event) {
            return _vm.$emit("refresh")
          },
          submit: _vm.editDiscount,
        },
        model: {
          value: _vm.updatedDiscount,
          callback: function ($$v) {
            _vm.updatedDiscount = $$v
          },
          expression: "updatedDiscount",
        },
      }),
      _vm._v(" "),
      _c("LinkedPharmacyDialog", {
        attrs: {
          discountId: _vm.discountDetails._id,
          subscribedPharmacies: _vm.discountDetails.subscribedPharmacies,
          isLinkedPharmacyDialogOpen: _vm.isLinkedPharmaciesDialogOpen,
        },
        on: {
          "update:isLinkedPharmacyDialogOpen": function ($event) {
            _vm.isLinkedPharmaciesDialogOpen = $event
          },
          "update:is-linked-pharmacy-dialog-open": function ($event) {
            _vm.isLinkedPharmaciesDialogOpen = $event
          },
          refresh: function ($event) {
            return _vm.$emit("refresh")
          },
          submit: _vm.assignDiscountToPharmacy,
        },
      }),
      _vm._v(" "),
      _c("DeleteDiscountDialog", {
        attrs: { isDeleteDiscountDialogOpen: _vm.isDeleteDiscountDialogOpen },
        on: {
          "update:isDeleteDiscountDialogOpen": function ($event) {
            _vm.isDeleteDiscountDialogOpen = $event
          },
          "update:is-delete-discount-dialog-open": function ($event) {
            _vm.isDeleteDiscountDialogOpen = $event
          },
          submit: _vm.deleteDiscount,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }